<template>
  <div class="dataCenter">
    <div class="contain_box">
      <div class="header">
        <div class="title">账号诊断 <i class="el-icon-question"></i></div>
        <div class="tip">每日十点更新</div>
      </div>
      <div class="radarMap" ref="radarMapRef"></div>
      <div class="legend_box"><span class="circle" style="background: #577cf7;"></span>你的账号<span class="circle" style="background: #f0925a;margin-left: 10px;"></span>同类作者</div>
      <div class="tab_box">
        <div :class="['list_item',{'active_list_item':activeId==item.id}]" v-for="item in tabList" :key="item.id" @click="activeTabItem(item)">{{ item.name }}</div>
      </div>
      <div class="show_Value">
        <div class="item">
          <div class="title">近7日{{ tabList[activeId-1].name }}</div>
          <div class="value">{{ value1 }}</div>
        </div>
        <div class="item">
          <div class="title">超过同类作者</div>
          <div class="value">{{ value2 }}</div>
        </div>
      </div>
    </div>
    <div class="operatingData">
      <div class="header">
        <div class="title">经营数据</div>
        <div class="left">
          <span class="button">近7日 <i class="el-icon-caret-bottom"></i></span>
          <span>自定义 <i class="el-icon-setting"></i></span>
        </div>
      </div>
      <div class="tip">预计每日12点前更新</div>
      <div class="show_data">
        <div class="left">作品</div>
        <div class="right">
          <div class="background">
            <span :class="[{'item':isLive==1}]" @click="changeLive(1)">投稿</span>
            <span :class="[{'item':isLive==2}]" @click="changeLive(2)">直播</span>
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>

      </div>
      <div class="works">
        <div :class="['show_item',{'active_show_item':activeWorkIndex==item.id}]" v-for="item in showWorkData" :key="item.id" @click="activeWorkItem(item)">
          <div class="name">{{ item.name }}<span v-if="item.value1!=0" :style="{color:item.value1>0?'#eb6452':'#70c77b','margin-left':'3px','font-size':'11px'}">{{item.value1>0?'+':''}}{{ item.value1 }}%</span></div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
      <div class="worksEcharts" style="display: flex;align-items: center;justify-content: center;color: #999;" v-if="activeWorkIndex==5 && isLive==2">暂无数据</div>
      <div class="worksEcharts" v-else ref="worksEchartsRef"></div>
      <div class="show_data">
        <div class="left">粉丝</div>
        <div class="right">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="works">
        <div :class="['show_item',{'active_show_item':activeFanIndex==item.id}]" v-for="item in showFanData" :key="item.id" @click="activeFanItem(item)">
          <div class="name">{{ item.name }}<span v-if="item.value1!=0" :style="{color:item.value1>0?'#eb6452':'#70c77b','margin-left':'3px','font-size':'11px'}">{{item.value1>0?'+':''}}{{ item.value1 }}%</span></div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
      <div class="worksEcharts" ref="fansEchartsRef"></div>
      <!--  -->
      <div class="show_data">
        <div class="left">收入</div>
        <div class="right">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="works">
        <div :class="['show_item',{'active_show_item':activeIncomeIndex==item.id}]" v-for="item in showIncomeData" :key="item.id" @click="activeIncomeItem(item)">
          <div class="name">{{ item.name }}<span v-if="item.value1!=0" :style="{color:item.value1>0?'#eb6452':'#70c77b','margin-left':'3px','font-size':'11px'}">{{item.value1>0?'+':''}}{{ item.value1 }}%</span></div>
          <div class="value">{{ item.value }}</div>
          <div class="name" v-if="item.id==2">
            <div>参与 0</div>
            <div>完成 0</div>
          </div>
          <div class="name" v-if="item.id==3">
            <div>金额 3565.6</div>
            <div>订单 114</div>
          </div>
        </div>
      </div>
      <div class="worksEcharts" ref="inComeEchartsRef"></div>
    </div>
    <div class="operatingData">
      <div class="header">
        <div class="title">推广数据</div>
        <div class="left">
          <span class="button">近7日 <i class="el-icon-caret-bottom"></i></span>
        </div>
      </div>
      <div class="show_data" style="margin-top: 10px;">
        <div class="left" style="font-weight: 600;">Dou+</div>
        <div class="right">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="showPromotiondata">
        <div class="data"><span>消耗量</span><span>0.00</span></div>
        <div class="data"><span>播放量</span><span>0</span></div>
      </div>
      <div class="show_data" style="margin-top: 10px;">
        <div class="left" style="font-weight: 600;">本地推</div>
        <div class="right">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="showPromotiondata">
        <div class="data"><span>消耗</span><span>--</span></div>
        <div class="data"><span>展示次数</span><span>--</span></div>
      </div>

    </div>

    <div class="observingAuthor">
      <div class="header">
        <div class="title">观测你的同类作者</div>
        <div class="tip">预计每日12点前更新</div>
      </div>
      <div class="tip_box">
        <span>你还没有设置观测的作者</span>
        <span style="color: #3b5985;">去设置</span>
      </div>

    </div>

  </div>
</template>
  
  <script>
import {
  operatingWorksData,
  operatingFanData,
  incomeData,
  liveData,
} from "./js/Operatingdata";
export default {
  data() {
    return {
      tabList: [
        {
          name: "播放量",
          id: 1,
          value1: "67.2万",
          value2: "99.83%",
        },
        {
          name: "互动率",
          id: 2,
          value1: "0.46%",
          value2: "99.63%",
        },
        {
          name: "投稿量",
          id: 3,
          value1: "40",
          value2: "99.8%",
        },
        {
          name: "粉丝净增",
          id: 4,
          value1: "77",
          value2: "96.71%",
        },
        {
          name: "完播率",
          id: 5,
          value1: "20%",
          value2: "79.83%",
        },
      ],
      activeId: 1,
      value1: "67.2万",
      value2: "99.83%",
      contributeData: [
        {
          name: "投稿数",
          value: "4",
          id: 1,
          unit: "",
          value1: 15.2,
        },
        {
          name: "播放量",
          value: "1.8万",
          id: 2,
          unit: "万",
          value1: 3.2,
        },
        {
          name: "完播率",
          value: "17.23%",
          id: 3,
          unit: "%",
          value1: 44,
        },
        {
          name: "互动指数",
          value: "2.32%",
          id: 4,
          unit: "%",
          value1: 0,
        },
        {
          name: "点赞量",
          value: "236",
          id: 5,
          unit: "",
          value1: -37.3,
        },
        {
          name: "作品搜索",
          value: "4975",
          id: 6,
          unit: "",
          value1: -46,
        },
        {
          name: "弹幕量",
          value: "0",
          id: 7,
          unit: "",
          value1: 0,
        },
        {
          name: "投稿数",
          value: "10.74",
          id: 8,
          unit: "",
          value1: 0,
        },
        {
          name: "封面点击",
          value: "0",
          id: 9,
          unit: "",
          value1: 0,
        },
      ],
      liveData: [
        {
          name: "观看人数",
          value: "--",
          id: 1,
          unit: "",
        },
        {
          name: "开播时长",
          value: "0.00",
          id: 2,
          unit: "",
        },
        {
          name: "点赞次数",
          value: "0",
          id: 3,
          unit: "",
        },
        {
          name: "评论人数",
          value: "0",
          id: 4,
          unit: "",
        },
        {
          name: "收获音浪",
          value: "--",
          id: 5,
          unit: "",
        },
      ],
      showWorkData: [],
      showFanData: [
        {
          name: "总粉丝量",
          value: "7081",
          id: 1,
          unit: "",
          value1: 0.9,
        },
        {
          name: "粉丝净增",
          value: "1",
          id: 2,
          unit: "",
          value1: -80,
        },
        {
          name: "取关粉丝",
          value: "11",
          id: 3,
          unit: "",
          value1: -28,
        },
        {
          name: "主页访问",
          value: "6383",
          id: 4,
          unit: "",
          value1: -54.5,
        },
        {
          name: "账号搜索",
          value: "139",
          id: 5,
          unit: "",
          value1: 56.2,
        },
      ],
      showIncomeData: [
        {
          name: "总收入",
          value: "118.5",
          id: 1,
          unit: "",
          value1: 420,
        },
        {
          name: "星图收入",
          value: "0",
          id: 2,
          unit: "",
          value1: 0,
        },
        {
          name: "电商收入",
          value: "118.5",
          id: 3,
          unit: "",
          value1: 0,
        },
      ],
      activeWorkIndex: 1,
      activeFanIndex: 1,
      activeIncomeIndex: 1,
      isLive: 1,
    };
  },
  props: {},
  mounted() {
    this.getEcharts();
    let obj = operatingWorksData.find(
      (item) => item.id == this.activeWorkIndex
    );
    let obj2 = operatingFanData.find((item) => item.id == this.activeFanIndex);
    let obj3 = incomeData.find((item) => item.id == this.activeIncomeIndex);
    this.$nextTick(() => {
      this.getWorkEcharts(obj.data, 1);
      this.getWorkEcharts(obj2.data, 2);
      this.getWorkEcharts(obj3.data, 3);
    });
    this.showWorkData = this.contributeData;
  },

  methods: {
    getEcharts() {
      var chart = this.$echarts.init(this.$refs.radarMapRef);
      const dataList = [
        {
          name: "你的账号",
          data: [
            { name: "播放量", value: 672, unit: "万" },
            { name: "互动率", value: 0.5, unit: "%" },
            { name: "投稿数", value: 40, unit: "" },
            { name: "粉丝净增", value: 77, unit: "" },
            { name: "完播率", value: 20, unit: "%" },
          ],
          color: "#587df7",
        },
        {
          name: "同类账号",
          data: [
            { name: "播放量", value: 255, unit: "" },
            { name: "互动率", value: 3, unit: "%" },
            { name: "投稿数", value: 2, unit: "" },
            { name: "粉丝净增", value: 2, unit: "" },
            { name: "完播率", value: 11.2, unit: "%" },
          ],
          color: "#f1a376",
        },
      ];

      const indicator = [
        { name: "播放量", max: 870 },
        { name: "互动率", max: 4 },
        { name: "投稿数", max: 40 },
        { name: "粉丝净增", max: 77 },
        { name: "完播率", max: 25 },
      ];

      // 构建单个学生的系列数据
      const buildSeriesForStudent = (studentData, studentIndex) => {
        const data = studentData.data.map((item) => item.value);
        const helper = data.map((item, index) => {
          const arr = new Array(data.length).fill(0);
          arr[index] = item;
          return arr;
        });
        return [data, ...helper].map((item, index) => {
          return {
            name: studentData.name,
            max: item.max,
            type: "radar",
            symbol: index === 0 ? "circle" : "none",
            symbolSize: 5,
            itemStyle: {
              color: "#fff",
              borderColor: index === 0 ? studentData.color : "transparent", // 标记边框颜色
              borderWidth: 1, // 标记边框宽度
            },
            lineStyle: {
              color: index === 0 ? studentData.color : "transparent",
            },
            areaStyle: {
              // 设置径向渐变
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "transparent", // 中心颜色，使用学生数据的颜色
                  },
                  {
                    offset: 1,
                    color: studentData.color, // 边缘颜色，透明
                  },
                ],
                global: false, // 缺省为 false
              },
              opacity: 0.1,
            },
            tooltip: {
              show: index === 0 ? false : true,
              formatter: () => {
                let res =
                  `<span style="color:#666;font-size:12px;padding-left:10px;">${
                    indicator[index - 1].name
                  }</span>` + "：<br>";
                for (let x of dataList) {
                  let str = `<span style="color:#666;font-size:12px;padding:10px;"><i style="display: inline-block;width: 8px;height: 8px;background: ${
                    x.color
                  };margin-right: 5px;border-radius: 50%;"></i> ${x.name}： ${
                    x.data[index - 1].value
                  }${x.data[index - 1].unit}<br></span>`;
                  res += str;
                }
                return `<div style=" box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.3);border-radius:4px;padding:5px;" >${res}</div>`;
              },
            },
            z: index === 0 ? 1 : 2,
            data: [item],
          };
        });
      };

      // 构建所有学生的系列数据
      const series = dataList.flatMap((studentData, index) =>
        buildSeriesForStudent(studentData, index)
      );

      let option = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgb(255,255,255)",
          textStyle: {
            color: "#333", // 修改为深色以便查看
          },
        },
        color: ["#ff5a2c", "#6776ff"],

        radar: {
          shape: "circle",
          indicator: indicator,
          radius: 66,
          splitArea: {
            // 'show': false
            areaStyle: {
              color: "transparent", // 每个圆的背景颜色
              shadowColor: "#32dadd", // 每个圈的阴影颜色
              shadowBlur: 10,
            },
          },
          name: {
            formatter: function (value, indicator) {
              // 查找对应的数据项
              let yourAccountData = dataList[0].data.find(
                (item) => item.name === indicator.name
              );
              let similarAccountData = dataList[1].data.find(
                (item) => item.name === indicator.name
              );
              return [
                `{a|${value}}`,
                `{b|${yourAccountData.value}${yourAccountData.unit}}/{c|${similarAccountData.value}${similarAccountData.unit}}`,
              ].join("\n");
            },

            rich: {
              a: {
                align: "center",
                fontSize: 14,
                lineHeight: 22,
                color: "#333",
                fontWeight: "bold",
                padding: [0, 0, 10, 0],
              },
              b: {
                align: "center",
                fontSize: 13,
                lineHeight: 22,
                fontWeight: "bold",
                color: "#4C7DFF",
              },
              c: {
                align: "center",
                fontSize: 13,
                lineHeight: 22,
                fontWeight: "bold",
                color: "#FF8C4C",
              },
            },
          },
          // legend: {
          //   data: dataList.map((item) => ({
          //     name: item.name,
          //     icon: "circle", // 图例的图标形状
          //     textStyle: {
          //       color: "#333", // 设置图例文本颜色
          //     },
          //     itemStyle: {
          //       color: item.color, // 设置图例图标的颜色
          //     },
          //   })),
          //   bottom: 0,
          //   left: "center",
          //   textStyle: {
          //     color: "#333", // 设置图例文本颜色
          //   },
          //   itemWidth: 10,
          //   itemHeight: 10,
          // },
        },
        series: series,
      };
      chart.setOption(option);

      const handleResize = () => {
        chart.resize();
      };

      window.addEventListener("load", handleResize);
      window.addEventListener("resize", handleResize);

      // 可以在组件销毁时解绑事件，避免内存泄漏
      // 假设在 Vue 组件中，可以在 beforeDestroy 钩子中执行
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("load", handleResize);
        window.removeEventListener("resize", handleResize);
      });
    },
    getWorkEcharts(y, type) {
      const today = new Date();
      // 生成近七日的日期数组，按从小到大排列
      const dates = [];
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        dates.push(`${month}-${day}`);
      }
      var chart = null;
      let index = 1;
      let arrData = [];
      if (type == 1) {
        chart = this.$echarts.init(this.$refs.worksEchartsRef);
        index = this.activeWorkIndex;
        arrData = this.showWorkData;
      } else if (type == 2) {
        chart = this.$echarts.init(this.$refs.fansEchartsRef);
        index = this.activeFanIndex;
        arrData = this.showFanData;
      } else {
        chart = this.$echarts.init(this.$refs.inComeEchartsRef);
        index = this.activeIncomeIndex;
        arrData = this.showIncomeData;
      }
      let option = {
        grid: {
          left: 42,
        },
        xAxis: {
          type: "category",
          data: dates,
          boundaryGap: false,
          splitLine: {
            show: false, // 隐藏 x 轴的分隔线
          },
          axisTick: {
            show: false, // 隐藏 x 轴的刻度线（即坐标文字旁的小竖线）
          },
          axisLabel: {
            show: true, // 保留 x 轴的标签,
            color: "#999999",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          formatter: (params) => {
            console.log(params);
            let res = `<div style="color:#666;box-shadow: 0 5px 10px 1px rgba(32, 32, 32, 0.05);padding:10px;border-radius:4px">
                <div >${params[0].axisValueLabel}<div>
                  <div style="display: flex;align-items: center;margin-top: 6px;font-size:14px;"><span style="width: 10px;height: 10px;border-radius: 10px;background: #93ade6;margin-right: 5px;"></span><span style="margin-right: 10px;">${
                    arrData[index - 1].name
                  }</span><span>${params[0].value}${
              arrData[index - 1].unit
            }</span><div>
                <div>`;
            return res;
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            formatter: function (value) {
              return value + arrData[index - 1].unit; // 给标签数字加上单位
            },
          },
          min: 0,
          max:
            index == 7 ||
            index == 9 ||
            (type == 3 && index == 2) ||
            (type == 1 &&
              this.isLive == 2 &&
              (index == 2 || index == 3 || index == 4))
              ? 5
              : void 0,
        },
        series: [
          {
            data: y,
            type: "line",
            smooth: true,
            color: "#587df7",
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
    activeTabItem(item) {
      this.activeId = item.id;
      this.value1 = item.value1;
      this.value2 = item.value2;
    },
    activeWorkItem(item) {
      this.activeWorkIndex = item.id;
      if (this.isLive == 1) {
        let obj = operatingWorksData.find(
          (item) => item.id == this.activeWorkIndex
        );
        this.getWorkEcharts(obj.data, 1);
      } else {
        if (item.id != 5) {
          let obj = liveData.find((item) => item.id == this.activeWorkIndex);
          this.$nextTick(() => {
            this.getWorkEcharts(obj.data, 1);
          });
        } else {
          let chart = this.$echarts.init(this.$refs.worksEchartsRef);
          this.$echarts.dispose(chart);
        }
      }
    },
    activeFanItem(item) {
      this.activeFanIndex = item.id;
      let obj = operatingFanData.find((item) => item.id == this.activeFanIndex);
      this.getWorkEcharts(obj.data, 2);
    },
    activeIncomeItem(item) {
      this.activeIncomeIndex = item.id;
      let obj = incomeData.find((item) => item.id == this.activeIncomeIndex);
      this.getWorkEcharts(obj.data, 3);
    },
    changeLive(id) {
      this.activeWorkIndex = 1;
      this.isLive = id;
      this.showWorkData = id == 1 ? this.contributeData : this.liveData;
    },
  },
};
</script>
  
  <style scoped lang="scss">
.dataCenter {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background: #f5f5f5;
  overflow-y: auto;
  height: 500px;
  // padding-top: 46px;
  box-sizing: border-box;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  .contain_box {
    width: 100%;
    padding: 20px 10px;
    background: #fff;
    box-sizing: border-box;
    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .tip {
        color: #999;
        font-size: 12px;
      }
      .title {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .radarMap {
      width: 100%;
      height: 300px;
    }
    .legend_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      font-size: 12px;
      .circle {
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 50%;
        color: #898a90;
        margin-right: 3px;
      }
    }
    .tab_box {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #f1f1f1;
      justify-content: space-evenly;
      .list_item {
        padding: 10px 0;
        color: #646566;
        cursor: pointer;
        border-bottom: 2px solid transparent;
      }
      .active_list_item {
        border-bottom: 2px solid #333333;
        color: #333333;
      }
    }
    .show_Value {
      display: flex;
      margin-top: 20px;
      .item {
        flex: 1;
        padding: 10px;
        background: #f5f5f5;
        border-radius: 4px;
        &:nth-of-type(1) {
          margin-right: 10px;
        }
        .title {
          text-align: center;
          color: #646566;
          font-size: 14px;
        }
        .value {
          text-align: center;
          color: #333333;
          font-weight: 600;
          margin-top: 5px;
        }
      }
    }
  }
  .operatingData {
    margin-top: 20px;
    width: 100%;
    padding: 20px 10px;
    background: #fff;
    box-sizing: border-box;
    .header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .title {
        font-weight: 700;
        font-size: 16px;
      }
      .left {
        color: #999;
        font-size: 14px;
        .button {
          margin-right: 10px;
        }
      }
    }
    .tip {
      color: #999;
      font-size: 12px;
      margin-top: 5px;
    }
    .show_data {
      display: flex;
      justify-content: space-between;
      height: 30px;
      align-items: center;
      .right {
        display: flex;
        align-items: center;
        .el-icon-arrow-right {
          margin-left: 5px;
          font-size: 16px;
          font-weight: 600;
        }
        .background {
          background: #f2f2f2;
          padding: 4px 8px;
          border-radius: 2px;
          font-size: 12px;
          .item {
            background: #fff;
            padding: 2px 3px;
          }
          span {
            margin-right: 5px;
            border-radius: 2px;
          }
        }
      }
      .left {
        font-weight: 600;
      }
    }
    .works {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-top: 10px;
      .show_item {
        width: 33.33%;
        // height: 56px;
        padding: 6px;
        padding-bottom: 10px;
        padding-right: 5px;
        box-sizing: border-box;
        border-radius: 4px;
        cursor: pointer;
        .name {
          font-size: 12px;
          color: #999;
        }
        .value {
          margin-top: 5px;
          font-weight: 600;
        }
      }
      .active_show_item {
        background: #fafafa;
      }
    }
    .showPromotiondata {
      display: flex;

      .data {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 5px;
        box-sizing: border-box;
        color: #999;
        &:nth-of-type(2) {
          margin-left: 5px;
        }
      }
    }
    .worksEcharts {
      width: 100%;
      height: 250px;
    }
  }
  .observingAuthor {
    margin: 20px 0;
    width: 100%;
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .header {
      width: 100%;

      .tip {
        color: #999;
        font-size: 12px;
        margin-top: 6px;
      }
      .title {
        font-weight: 700;
        font-size: 16px;
      }
    }
    .tip_box {
      background: #f8f8f8;
      width: 100%;
      padding: 5px 8px;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
  